module.exports = __webpack_public_path__ + "img/settings.dd9cd10e.svg";